module.exports = __webpack_public_path__ + "static/media/holiday.e9a284ec.jpg";